export default {
  postalCode: '',
  regionName: '',
  muniName: '',
  streetAddress: '',
  buildingName: '',
  lat: 0,
  lng: 0
};
